import apiService from "./apiService";

export default {
  /**
   *  Gets all Categories
   * @param {string} endpoint
   */
  getCategories: async () => apiService.get("categories"),

  getCategory: async categoryId =>
    apiService.get("categories/".concat(categoryId)),

  createCategory: async data =>
    apiService.post("categories", data, null, "Category created."),

  updateCategory: async (categoryId, data) =>
    apiService.post("categories/".concat(categoryId), data),

  deleteCategory: async categoryId =>
    apiService.del("categories/".concat(categoryId), "Category deleted.")
};



// WEBPACK FOOTER //
// ./src/services/api/categoryService.js